// Libraries
import styled, { css } from 'styled-components'

export const StyledWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 30px 0 0 65px;
  ${({ theme }) => css`
    ${theme.media.desktop} {
      justify-content: flex-end;
    }
    ${theme.media.tablet} {
      justify-content: center;
      margin: 0;
    }
  `}
`;

export const BookClosed = styled.img`
  width: 245px;
  height: 421px;
  ${({ theme }) => css`
    ${theme.media.laptop} {
      width: 30%;
      height: auto;
    }
    ${theme.media.tablet} {
      width: 60%;
      justify-content: center;
    }
    ${theme.media.mobileL} {
      width: 80%;
    }
  `}
`;

export const BookOpened = styled.img`
  width: 664px;
  height: 396px;
  ${({ theme }) => css`
    ${theme.media.laptop} {
      width: 60%;
      height: auto;
    }
    ${theme.media.tablet} {
      display: none;
    }
  `}
`;